// @ts-nocheck
import {Platform} from 'react-native';
import analytics from '../../imports/Analytics';

export const AnalyticsEvent = (props: {
  type:
    | 'sign_up'
    | 'page_view'
    | 'trip'
    | 'purchase'
    | 'confirmed_sign_up'
    | 'StartTrip'
    | 'paid_deposit';

  params: {
    [key: string]: 'motor' | 'bicycle' | 'scooter' | string | number;
  };
}) => {
  const {type, params}: any = props;
  if (Platform.OS === 'web') {
    analytics.logEvent(type, params);
  } else {
    if ( !__DEV__ && Platform.OS === 'android') {
      analytics().logEvent(type, params);
    }
  }
};

export const AnalyticsUserProperties = (params: any) => {
  try {
    if (Platform.OS === 'web') {
      analytics.setUserProperties(params);
    } else {
      if (!__DEV__ && Platform.OS === 'android') {
        analytics().setUserProperties(params);
      }
    }
  } catch (err) {
    console.log('Analytic_error', err);
  }
};

export const AnalyticsAppInstanceId = () => {
  if (Platform.OS === 'web') {
    analytics.getAppInstanceId();
  } else {
    if (!__DEV__ && Platform.OS === 'android') {
      analytics().getAppInstanceId();
    }
  }
};
